<div class="mb-checkout-contact-details"
     data-cy="mb-checkout-contact-details">
  <form [formGroup]="contactDetailsForm">
    <div class="row no-gutters mb-4">
      <ng-container *ngIf="isPurchaseCheckoutType; else requestCheckoutType">
        <div class="col-sm-12 col-md-9 pl-0 text-left mb-checkout-headline" data-cy="mb-checkout-headline">{{ 'contact.purchaseHeadline1' | cxTranslate }}</div>
        <div class="col-sm-12 col-md-3 mt-3 mt-md-0 mb-3 text-md-right mb-checkout-mandatory-text" data-cy="mb-form-contact-details-mandatory-text">{{ 'mbcommon.mandatory' | cxTranslate }}</div>
      </ng-container>
      <ng-template #requestCheckoutType>
        <div class="col-12 pl-0 mb-3 mb-checkout-headline" data-cy="mb-checkout-headline">{{ 'contact.requestHeadline1' | cxTranslate }}</div>
        <div class="col-sm-12 col-md-9 mb-checkout-sub-headline" data-cy="mb-checkout-sub-headline"> {{ 'contact.requestHeadline2' | cxTranslate }}</div>
        <div class="col-sm-12 col-md-3 mt-3 mt-md-0 text-md-right mb-checkout-mandatory-text" data-cy="mb-form-contact-details-mandatory-text">{{ 'mbcommon.mandatory' | cxTranslate }}</div>
      </ng-template>
    </div>

    <mb-checkout-salutation-form-partial [formGroup]="contactDetailsForm"
                                         [salutations]="titles$ | async"
                                         [selectedSalutation]="selectedSalutation"
                                         [salutationLabelKey]="'contact.salutation'"
                                         [isFormDisabled]="isFormDisabled()">
    </mb-checkout-salutation-form-partial>

    <mb-checkout-title-form-partial [formGroup]="contactDetailsForm"
                                    [academicDegrees]="academicDegrees$ | async"
                                    [selectedAcademicDegree]="selectedAcademicDegree"
                                    [academicDegreeLabelKey]="'contact.title'"
                                    [isFormDisabled]="isFormDisabled()">
    </mb-checkout-title-form-partial>

    <mb-checkout-contact-base-form-partial [formGroup]="contactDetailsForm"
                                           [isEmailDisabled]="isEmailDisabled()"
                                           [firstNameLabelKey]="'contact.firstName'"
                                           [lastNameLabelKey]="'contact.lastName'"
                                           [emailLabelKey]="'contact.email'"
                                           [phoneNumberLabelKey]="'contact.phoneNumber'"
                                           [isFormDisabled]="isFormDisabled()">
    </mb-checkout-contact-base-form-partial>

    <mb-checkout-job-title-form-partial [formGroup]="contactDetailsForm"
                                        [jobTitles]="jobTitles$ | async"
                                        [selectedRole]="selectedRole"
                                        [roleLabelKey]="'contact.role'"
                                        [isFormDisabled]="isFormDisabled()">
    </mb-checkout-job-title-form-partial>

    <mb-checkout-customer-no-form-partial [formGroup]="contactDetailsForm"
                                          [customerNoLabelKey]="'contact.customerNumber'"
                                          [isFormDisabled]="isFormDisabled()">
    </mb-checkout-customer-no-form-partial>

    <div class="row no-gutters">
      <div class="col-12 col-md mr-4 mt-2 order-2 order-md-1">
        <button data-cy="mb-checkout-contact-details-back-btn"
                class="btn btn-block btn-secondary mb-buttons"
                type="button"
                (click)="back()">
          {{ 'navigationPage.backBtn' | cxTranslate }}
        </button>
      </div>
      <div class="col-12 col-md mt-2 order-1 order-md-2">
        <button data-cy="mb-checkout-contact-details-next-btn"
                class="btn btn-block btn-primary mb-buttons"
                type="button"
                mbOneClickAllowed
                (click)="next()">
          {{ 'navigationPage.nextBtn' | cxTranslate }}
        </button>
      </div>
    </div>
  </form>
</div>

